import ProductSaleList from './ProductSaleList';

export default ProductSaleList;